export const apiUrl = "https://dev.fastamoni.com/api/";
